import { uuid, varchar, boolean } from 'drizzle-orm/pg-core/columns';
import { pgTable } from 'drizzle-orm/pg-core/table';
import { foreignKey } from 'drizzle-orm/pg-core/foreign-keys';
import { commonFields } from './common-fields';
import { files } from './files';
import { relations } from 'drizzle-orm/relations';
import { InferSelectModel } from 'drizzle-orm/table';
import { identities } from './identities';

export type DocumentSignature = InferSelectModel<typeof documentSignatures>;

export const documentSignatures = pgTable(
  'document_signatures',
  {
    ...commonFields,
    signed: boolean().default(false).notNull(),
    fileId: uuid().notNull(),
    headerPrimaryLang: varchar(),
    headerSecondaryLang: varchar(),
    authMethodToView: varchar(),
    authMethodToSign: varchar(),
    deliveryMethod: varchar(),
    email: varchar(),
    signatoryId: uuid(),
    proxyId: uuid(),
    scriveSignTime: varchar(),
    scriveRejectedTime: varchar(),
    scriveRejectionReason: varchar(),
    scriveReadInvitationTime: varchar(),
    scriveEmailDeliveryStatus: varchar(),
    scriveSeenTime: varchar(),
    zignedParticipantId: varchar(),
    zignedParticipantStatus: varchar(),
    zignedParticipantRole: varchar(),
    zignedParticipantSigningRoomLink: varchar(),
  },
  table => {
    return [
      {
        documentSignaturesFileIdFkey: foreignKey({
          columns: [table.fileId],
          foreignColumns: [files.id],
          name: 'document_signatures_file_id_fkey',
        }),
        documentSignaturesProxyIdFkey: foreignKey({
          columns: [table.proxyId],
          foreignColumns: [identities.id],
          name: 'document_signatures_proxy_id_fkey',
        }),
        documentSignaturesSignatoryIdentityIdFkey: foreignKey({
          columns: [table.signatoryId],
          foreignColumns: [identities.id],
          name: 'document_signatures_signatory_identity_id_fkey',
        }),
      },
    ];
  },
);

export const documentSignaturesRelations = relations(documentSignatures, ({ one }) => ({
  file: one(files, {
    fields: [documentSignatures.fileId],
    references: [files.id],
  }),
  identity_proxyId: one(identities, {
    fields: [documentSignatures.proxyId],
    references: [identities.id],
    relationName: 'documentSignatures_proxyId_identities_id',
  }),
  identity_signatoryId: one(identities, {
    fields: [documentSignatures.signatoryId],
    references: [identities.id],
    relationName: 'documentSignatures_signatoryId_identities_id',
  }),
}));
